enum StripeSubscriptionStatus {
  ACTIVE = "ACTIVE",
  PAST_DUE = "PAST_DUE",
  UNPAID = "UNPAID",
  CANCELED = "CANCELED",
  INCOMPLETE = "INCOMPLETE",
  INCOMPLETE_EXPIRED = "INCOMPLETE_EXPIRED",
  TRIALING = "TRIALING",
  ALL = "ALL",
  ENDED = "ENDED",
}

export default StripeSubscriptionStatus;

export const getStripeSubscriptionStatusI18nKey = function (status: StripeSubscriptionStatus) {
  switch (status) {
    case StripeSubscriptionStatus.ACTIVE:
      return "StripeSubscriptionStatus.Active";
    case StripeSubscriptionStatus.PAST_DUE:
      return "StripeSubscriptionStatus.PastDue";
    case StripeSubscriptionStatus.UNPAID:
      return "StripeSubscriptionStatus.Unpaid";
    case StripeSubscriptionStatus.CANCELED:
      return "StripeSubscriptionStatus.Canceled";
    case StripeSubscriptionStatus.INCOMPLETE:
      return "StripeSubscriptionStatus.Incomplete";
    case StripeSubscriptionStatus.INCOMPLETE_EXPIRED:
      return "StripeSubscriptionStatus.IncompleteExpired";
    case StripeSubscriptionStatus.TRIALING:
      return "StripeSubscriptionStatus.Trialing";
    case StripeSubscriptionStatus.ALL:
      return "StripeSubscriptionStatus.All";
    case StripeSubscriptionStatus.ENDED:
      return "StripeSubscriptionStatus.Ended";
  }
};
